import { createReducer, createNamespacer } from './../../commons/js/utils/reducer';
import { fromPairs as _fromPairs } from 'lodash';

const initialState = {
    moveSpools: {
        moveToPackage: {
            value: "",
            error: "",
            showError: "",
        },
    },
}

const moveSpools = createNamespacer("MOVE_SPOOLS")

export const moveSpoolReducer = createReducer(initialState.moveSpools, {
    [moveSpools("SET_MOVE_PACKAGE")]: (state, action) => {
        return {
            ...state,
            moveToPackage: {
                ...state.moveToPackage,
                value: action.payload.value,
            },
        }
    },

    [moveSpools("SET_FIELD_ERRORS")]: (state, action) => {
        let errors = action.payload.value;

        const loadedFields = _fromPairs(Object.entries(errors).map((error) => {
            const [key, value] = error;
            return [key, {
                ...state[key],
                error: value
            }]
        }))

        return {
            ...state,
            ...loadedFields,
        }
    },

    [moveSpools("CLEAR_FORM")]: (state, action) => {
        return {
            ...initialState.moveSpools
        }
    },
})